module.exports = __webpack_public_path__ + "img/gestures_cn.fe22fb6.jpg";